import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import {
    getHomeRouteForLoggedInUser,
    getUserData,
    isUserLoggedIn,
} from '@/auth/utils'
import { canNavigate } from '@/libs/acl/routeProtection'

import home from './routes/home'
import pages from './routes/pages'
import portal from './routes/portal'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [
        { path: '/', redirect: { name: 'home' } },
        ...pages,
        ...home,
        ...portal,

        {
            path: '*',
            redirect: 'error-404',
        },
    ],
})

router.beforeEach((to, _, next) => {
    const isLoggedIn = isUserLoggedIn()

    if (to.name === 'datafast-callback' || to.path === '/datafast-callback') {
        return next()
    }

    if (!canNavigate(to)) {
        if (!isLoggedIn) {
            return next({ name: 'auth-login' })
        }

        return next({ name: 'misc-not-authorized' })
    }

    if (to.meta.redirectIfLoggedIn && isLoggedIn) {
        const userData = getUserData()
        next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
    }

    return next()
})

export default router
